export const state = {
  docMaster: [],
};
